import SmartphoneIcon from "@mui/icons-material/Smartphone";

interface IIcon {
  color: string;
}

const SmartphoneDisonnected: React.FC<IIcon> = ({ color }) => {
  return <SmartphoneIcon sx={{ color }} />;
};

export default SmartphoneDisonnected;
